/** @file Exhaustiveness helper for discriminated unions. */
export function assertNever(x: never): never {
  throw new Error(`Unexpected value: ${JSON.stringify(x)}`);
}
